import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import Loader from "../../components/shared/Loader";
import { updateMeta } from "../../store/actions/metaAction";
import { useHistory } from "react-router-dom";

const WorkShow = ({ match }) => {
	const {
		params: { workID },
	} = match;

	const auth = useSelector(state => state.auth.user);
	const dispatch = useDispatch();
	const history = useHistory();

	const [loading, setLoading] = useState(true);
	const [title, setTitle] = useState("");
	const [titleEn, setTitleEn] = useState("");
	const [picture, setPicture] = useState(null);
	const [pictureMeta, setPictureMeta] = useState("");
	const [media, setMedia] = useState(null);
	const [mediaType, setMediaType] = useState(null); // "image" or "video"

	useEffect(() => {
		onStart();
	}, []);

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "تعديل تفاصيل العمل",
				breadcrumb: "الأعمال",
				button: { show: false },
			})
		);

		axios
			.get(`${process.env.REACT_APP_API_URL}/posts/${workID}`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(response => {
				const post = response.data.data.data;
				setTitle(post.title.ar);
				setTitleEn(post.title.en);
				setPicture(post.image);
				setPictureMeta(post.imageMeta);
				setMedia(post.image);

				const ext = post.image?.split(".").pop().toLowerCase();
				if (["jpg", "jpeg", "png", "webp", "gif"].includes(ext)) {
					setMediaType("image");
				} else if (["mp4", "mov", "avi", "webm"].includes(ext)) {
					setMediaType("video");
				}

				setLoading(false);
			})
			.catch(() => {
				toast.error("خطأ، برجاء المحاولة لاحقاً!");
			});
	};

	const handleMediaUpload = e => {
		const file = e.target.files[0];
		if (!file) return;

		const formData = new FormData();
		formData.append("file", file);
		setLoading(true);

		axios
			.post(`${process.env.REACT_APP_API_URL}/upload`, formData, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
					"Content-Type": "multipart/form-data",
				},
			})
			.then(res => {
				const uploadedFileName = res.data.data.name;
				setPicture(uploadedFileName); // Save to send in PUT request
				setMedia(uploadedFileName); // Display preview

				if (file.type.startsWith("image/")) {
					setMediaType("image");
				} else if (file.type.startsWith("video/")) {
					setMediaType("video");
				}

				toast.success("تم رفع الوسيط بنجاح!");
			})
			.catch(() => {
				toast.error("حدث خطأ أثناء رفع الوسيط!");
				setMedia(null);
				setMediaType(null);
			})
			.finally(() => {
				setLoading(false);
			});
	};

	const handleSubmit = e => {
		e.preventDefault();

		const data = {
			title: {
				ar: title,
				en: titleEn,
			},
			image: picture,
			imageMeta: pictureMeta,
		};

		setLoading(true);

		axios
			.put(
				`${process.env.REACT_APP_API_URL}/posts/${workID}`,
				{
					category_id: 19,
					admin_id: auth.id,
					data: data,
				},
				{
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
					},
				}
			)
			.then(() => {
				toast.success("تم تحديث بيانات العمل بنجاح!");
				history.push("/works/index");
			})
			.catch(() => {
				toast.error("خطأ، برجاء المحاولة مره اخرى!");
			})
			.finally(() => {
				setLoading(false);
			});
	};

	return (
		<section>
			{loading && <Loader />}
			<form onSubmit={handleSubmit}>
				<div className="row">
					<div className="col-md-9">
						<div className="card">
							<div className="card-body">
								<div className="row">
									<div className="col-md-12">
										<div className="form-item">
											<label htmlFor="title">العنوان</label>
											<input
												type="text"
												id="title"
												required
												value={title}
												onChange={e => setTitle(e.target.value)}
											/>
										</div>
									</div>
									<div className="col-md-12">
										<div className="form-item">
											<label htmlFor="titleEn">العنوان بالانجليزية</label>
											<input
												type="text"
												id="titleEn"
												dir="ltr"
												required
												value={titleEn}
												onChange={e => setTitleEn(e.target.value)}
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div className="col-md-3">
						<div className="card">
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="media">الصورة / الفيديو</label>

									<div className="form-item">
										<input
											type="text"
											id="pictureMeta"
											onChange={e => setPictureMeta(e.target.value)}
											value={pictureMeta}
											placeholder="ادخل وصف الصورة"
										/>
									</div>

									<input
										type="file"
										accept="image/*,video/*"
										onChange={handleMediaUpload}
										id="media"
									/>

									{media && mediaType === "image" && (
										<div className="img-holder">
											<img
												src={process.env.REACT_APP_MAIN_URL + media}
												alt="avatar"
												className="imagePreview"
											/>
										</div>
									)}

									{media && mediaType === "video" && (
										<div className="img-holder">
											<video
												src={process.env.REACT_APP_MAIN_URL + media}
												style={{ width: "100%" }}
												controls
											/>
										</div>
									)}
								</div>
							</div>
						</div>

						<div className="form-item mt-3">
							<button className="bt bt-success btn-block">ارسال</button>
						</div>
					</div>
				</div>
			</form>
		</section>
	);
};

export default WorkShow;
